import type { MessageSkillMention } from '../types/chat';
import type { MentionPickerItem } from './normalize-mention-search';
import type { PromptInsertContext } from './insert-prompt-into-message';

/** Removes the active `/…` trigger and query from the message. */
export function clearMentionTrigger({ before, after }: PromptInsertContext): string {
  return `${before}${after}`;
}

export function appendSkillToSelection(
  skills: MentionPickerItem[],
  skill: MentionPickerItem
): MentionPickerItem[] {
  if (skills.some((entry) => entry.id === skill.id)) return skills;
  return [...skills, skill];
}

export function toMessageSkillMentions(skills: MentionPickerItem[]): MessageSkillMention[] {
  return skills.map(({ id, title, iconUrl }) => ({ id, title, iconUrl }));
}

export function buildMessageWithSelectedSkills(
  message: string,
  skills: MentionPickerItem[]
): string {
  const trimmed = message.trim();
  if (skills.length === 0) return trimmed;

  const skillRefs = skills.map((skill) => `/${skill.title}`).join(' ');
  return trimmed ? `${skillRefs} ${trimmed}` : skillRefs;
}
